import React from 'react'
import ContentLoader from 'react-content-loader'

const SearchLoader = ({ pageRange = 10 }) => {
  const rowHeight = 39
  const height = rowHeight * (pageRange + 1)
  const rows = Array.from(Array(pageRange).keys()).map((row) => {
    const y = rowHeight * row + rowHeight
    return (
      <React.Fragment key={row}>
        <rect x='15' y={y} rx='3' ry='3' width='140' height='12' />
        <rect x='200' y={y} rx='3' ry='3' width='200' height='12' />
        <rect x='500' y={y} rx='3' ry='3' width='120' height='12' />
        <rect x='740' y={y} rx='3' ry='3' width='110' height='12' />
      </React.Fragment>
    )
  })

  return (
    <ContentLoader
      speed={2}
      width={890}
      height={height}
      viewBox={`0 0 890 ${height}`}
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
    >
      {rows}
    </ContentLoader>
  )
}

export default SearchLoader
